import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';

import { ColorPickerModule } from 'ngx-color-picker';
import { CellsModule } from '../cells/cells.module';
import { SharedModule } from '../shared/shared.module';
import { MediaCenterModule } from '../media-center/media-center.module';

import { CircleInputComponent } from './circle-input/circle-input.component';
import { ValidationErrorsComponent } from './validation-errors/validation-errors.component';
import { IconValidationErrorsComponent } from './icon-validation-errors/icon-validation-errors.component';
import { ReactiveMediaInputComponent } from './reactive-media-input/reactive-media-input.component';
import { ReactiveTextInputComponent } from './reactive-text-input/reactive-text-input.component';
import { ReactiveDateInputComponent } from './reactive-date-input/reactive-date-input.component';
import { ReactiveTextareaInputComponent } from './reactive-textarea-input/reactive-textarea-input.component';
import { ReactivePasswordInputComponent } from './reactive-password-input/reactive-password-input.component';
import { ReactiveSelectInputComponent } from './reactive-select-input/reactive-select-input.component';
import { ReactiveRadioInputComponent } from './reactive-radio-input/reactive-radio-input.component';
import { ReactiveCheckboxInputComponent } from './reactive-checkbox-input/reactive-checkbox-input.component';
import { ReactiveTableComponent } from './reactive-table/reactive-table.component';
import { ReactiveTimestampInputComponent } from './reactive-timestamp-input/reactive-timestamp-input.component';
import { SelectorInputIconComponent } from './selector-input-icon/selector-input-icon.component';
import { SelectorInputLocationComponent } from './selector-input-location/selector-input-location.component';
import { SelectorInputDateComponent } from './selector-input-date/selector-input-date.component';
import { SelectorInputTimezoneComponent } from './selector-input-timezone/selector-input-timezone.component';
import { SelectorInputCountriesComponent } from './selector-input-countries/selector-input-countries.component';
import { SelectorInputAreaComponent } from './selector-input-area/selector-input-area.component';
import { SelectorInputCategoryComponent } from './selector-input-category/selector-input-category.component';
import { SelectorInputClassificationComponent } from './selector-input-classification/selector-input-classification.component';
import { SelectorInputCurrencyComponent } from './selector-input-currency/selector-input-currency.component';
import { SelectorInputPeriodComponent } from './selector-input-period/selector-input-period.component';
import { ReactiveDurationInputComponent } from './reactive-duration-input/reactive-duration-input.component';
import { ReactiveLockedInputComponent } from './reactive-locked-input/reactive-locked-input.component';
import { ReactiveColorInputComponent } from './reactive-color-input/reactive-color-input.component';
import { NgxModule } from '../ngx.module';
import { ReactiveInputKeyWordComponent } from './reactive-input-key-word/reactive-input-key-word.component';
import { ReactiveSelctedOwnerComponent } from './reactive-selcted-owner/reactive-selcted-owner.component';
import { AbstractTooltip } from '../abstract-tooltip/abstract-tooltip.module';
import { MenuHolderComponent } from '../+merchant/+dashboard/menus/menu-holder/menu-holder.component';
import { LinkPreviewCellComponent } from '../cells/link-preview-cell/link-preview-cell.component';
import { ImageCellComponent } from '../cells/image-cell/image-cell.component';
import { VideoCellComponent } from '../cells/video-cell/video-cell.component';
import { AudioCellComponent } from '../cells/audio-cell/audio-cell.component';
import { ContactCellComponent } from '../cells/contact-cell/contact-cell.component';
import { TextFileCellComponent } from '../cells/text-file-cell/text-file-cell.component';
import { ColoredTextCellComponent } from '../cells/colored-text-cell/colored-text-cell.component';
import { CalendarPreviewCellComponent } from '../cells/calendar-preview-cell/calendar-preview-cell.component';
import { InstantCellComponent } from '../cells/instant-cell/instant-cell.component';
import { MapCellComponent } from '../cells/map-cell/map-cell.component';
import { StickerCellComponent } from '../cells/sticker-cell/sticker-cell.component';
import { GifCellComponent } from '../cells/gif-cell/gif-cell.component';
import { FileCellComponent } from '../cells/file-cell/file-cell.component';
import { TextCellComponent } from '../cells/text-cell/text-cell.component';
import { BubbelCellComponent } from '../cells/bubbel-cell/bubbel-cell.component';
import { MessageOptionsComponent } from '../cells/message-options/message-options.component';
import { ReplyCellComponent } from '../cells/reply-cell/reply-cell.component';
import { PostCellComponent } from '../cells/post-cell/post-cell.component';
import { UiSwitchModule } from 'ngx-toggle-switch';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatTooltipModule,
    BsDatepickerModule,
    BsDropdownModule,
    MatRadioModule,
    MatCheckboxModule,
    MatDialogModule,
    SharedModule,
    CellsModule,
    UiSwitchModule,
    MediaCenterModule,
    ColorPickerModule,
    NgxModule,
    FormsModule,
    AbstractTooltip
  ],
  declarations: [
    CircleInputComponent,
    ValidationErrorsComponent,
    IconValidationErrorsComponent,
    ReactiveMediaInputComponent,
    ReactiveTextInputComponent,
    ReactiveDateInputComponent,
    ReactiveDurationInputComponent,
    ReactiveTextareaInputComponent,
    ReactivePasswordInputComponent,
    ReactiveSelectInputComponent,
    ReactiveRadioInputComponent,
    ReactiveCheckboxInputComponent,
    ReactiveLockedInputComponent,
    ReactiveColorInputComponent,
    ReactiveTableComponent,
    ReactiveTimestampInputComponent,
    SelectorInputIconComponent,
    SelectorInputLocationComponent,
    SelectorInputDateComponent,
    SelectorInputTimezoneComponent,
    SelectorInputCountriesComponent,
    SelectorInputAreaComponent,
    SelectorInputCategoryComponent,
    SelectorInputClassificationComponent,
    SelectorInputCurrencyComponent,
    SelectorInputPeriodComponent,
    ReactiveInputKeyWordComponent,
    ReactiveSelctedOwnerComponent
  ],
  exports: [
    CircleInputComponent,
    ValidationErrorsComponent,
    IconValidationErrorsComponent,
    ReactiveMediaInputComponent,
    ReactiveTextInputComponent,
    ReactiveDateInputComponent,
    ReactiveDurationInputComponent,
    ReactiveTextareaInputComponent,
    ReactivePasswordInputComponent,
    ReactiveSelectInputComponent,
    ReactiveRadioInputComponent,
    ReactiveCheckboxInputComponent,
    ReactiveLockedInputComponent,
    ReactiveColorInputComponent,
    ReactiveTableComponent,
    ReactiveTimestampInputComponent,
    SelectorInputIconComponent,
    SelectorInputLocationComponent,
    SelectorInputDateComponent,
    SelectorInputTimezoneComponent,
    SelectorInputCountriesComponent,
    SelectorInputAreaComponent,
    SelectorInputCategoryComponent,
    SelectorInputClassificationComponent,
    SelectorInputCurrencyComponent,
    SelectorInputPeriodComponent,
    ReactiveInputKeyWordComponent,
    ReactiveSelctedOwnerComponent,
    MenuHolderComponent,
    LinkPreviewCellComponent,
    ImageCellComponent,
    VideoCellComponent,
    AudioCellComponent,
    ContactCellComponent,
    TextFileCellComponent,
    MapCellComponent,
    StickerCellComponent,
    GifCellComponent,
    FileCellComponent,
    TextCellComponent,
    BubbelCellComponent,
    PostCellComponent,
    ReplyCellComponent,
    MessageOptionsComponent,
    InstantCellComponent,
    CalendarPreviewCellComponent,
    ColoredTextCellComponent
  ]
})
export class AbstractControlsModule { }
